import React, { Component } from "react";
import dataJSON from "../../static/api/data.json";
import Slider from "../Helpers/Slider/Slider";
import "./Miflagot.scss";
import PopupError from "../Popup/PopupError.jsx";
import { apiURL } from "../Services/Base.js";
import Loading from "../Services/Loading/Loading.jsx";
import { mobile } from "../Services/Agent.js";

const InnerItem = props => {
    return (
        <div onClick={() => {
            props.setClick(props.index);
            props.setData(props);
        }}
            className={`item ${props.isActive ? " active" : ""} image-${props.image}`}>
            <div className="bluefade"></div>
            <div className="image">
                <div className="points-circle">
                    <div className="points">
                        {props.mandats}
                    </div>
                </div>
            </div>
            <div className="miflaga">{props.name}</div>
        </div>
    )
}
export default class Miflagot extends Component {
    constructor() {
        super();
        this.state = {
            OwlRef: null,
            itemsClicked: {},
            items: {},
            data: [],
            dateUpdated: "",
            renderSlider: false
        }
    }
    componentDidMount() {
        window.setTimeout(() => {
            this.setClick(0);
            this.setClick(0);
        }, 150);
        this.getData(this.getPollsByParty);
        // window.addEventListener("resize", () => {
        //     this.setState({
        //         renderSlider: true
        //     }, () => {
        //         window.setTimeout(() => {
        //             this.setState({
        //                 renderSlider: false
        //             });
        //         }, 250);
        //     });
        // })
    }
    getData = (callback) => {
        fetch(`${apiURL}polls/Get_all`, {
            "Content-Type": "application/json"
        }).then(response => response.json()).then(data => {
            this.setState({
                data: data
            }, callback);
        }).catch(e => console.log(e));
    }
    getPollsByParty = () => {
        const { data } = this.state;
        let _data = [];

        if (data.filter(k => k.PollAuthor == 6).length == 0) {
            //all
            _data = data.sort((a, b) => {
                // return b.ID - a.ID;
                return new Date(b.PollDate) - new Date(a.PollDate);
            })[0];
        } else {
            // Only Manual (6) / Ulpan (5) / Yedioth (4)
            _data = data.filter(k => k.PollAuthor == 6).sort((a, b) => {
                return new Date(b.PollDate) - new Date(a.PollDate);
            })[0];
        }


        let byParty = this.calCulatDateParties(_data);
        let proxyData = [];

        dataJSON.map((item, index) => {
            let miflaga = byParty.filter(k => k.Miflaga == item.name);
            if (miflaga.length == 1) {
                proxyData.push({
                    name: miflaga[0].Miflaga,
                    image: item.image,
                    mandats: miflaga[0].Mandat
                })
            }
        })

        // let realDate = _data[_data.length - 1].PollDate.split("T")[0].split("-");
        let realDate = _data.PollDate.split("T")[0].split("-");
        this.setState({
            dateUpdated: `${realDate[2]}.${realDate[1]}.${realDate[0]}`,
            data: proxyData
        })
    }
    calCulatDateParties = (data, isSummary = false) => {
        let parties = {}, partiesArray = [];
        // data.forEach(obj => {
        let _parties = data.PollMiflaga.filter(k => k.Mandat != null);
        _parties.map((item, index) => {
            parties = {
                ...parties,
                [item.Miflaga]: {
                    ...parties[item.Miflaga],
                    Miflaga: item.Miflaga,
                    Mandat: item.Mandat + (isSummary ? (parties[item.Miflaga] ? parties[item.Miflaga].Mandat : 0) : 0),
                    Times: 1 + (isSummary ? (parties[item.Miflaga] ? parties[item.Miflaga].Times : 0) : 0),
                }
            }
        });
        // })

        for (let key in parties) {
            partiesArray.push(parties[key])
        }
        return partiesArray;
    }
    setData = item => {
        let { items } = this.state;
        if (items[item.index] != null) {
            delete items[item.index];
        } else {
            items = {
                ...items,
                [item.index]: {
                    ...items[item.index],
                    Miflaga: item.name,
                    Mandats: items && items[item.index] ?
                        (items[item.index].Mandats == 0 ? item.mandats : 0) : item.mandats
                }
            }
        }
        this.setState({
            items
        }, () => this.checkCombinations(item))
    }
    checkCombinations = (item) => {
        let { items, itemsClicked } = this.state;
        let parties = [], willNotSit = false, badMiflaga = "";
        for (let key in items) {
            parties.push(items[key]);
        }

        switch (item.name) {
            case "ישראל ביתנו":
                ["הרשימה המשותפת", "יהדות התורה", "ש\"ס", "הליכוד"].forEach(obj => {
                    if (parties.filter(k => k.Miflaga == obj).length > 0) {
                        badMiflaga = obj;
                        willNotSit = true;
                    }
                })
                break;
            case "הליכוד":
                ["הרשימה המשותפת", "העבודה", "מרצ", "יש עתיד", "תקווה חדשה", "ישראל ביתנו"].forEach(obj => {
                    if (parties.filter(k => k.Miflaga == obj).length > 0) {
                        badMiflaga = obj;
                        willNotSit = true;
                    }
                })
                break;
            case "ימינה":
                ["הרשימה המשותפת"].forEach(obj => {
                    if (parties.filter(k => k.Miflaga == obj).length > 0) {
                        badMiflaga = obj;
                        willNotSit = true;
                    }
                })
                break;
            case "תקווה חדשה":
                ["הליכוד", "הרשימה המשותפת", "הציונות הדתית"].forEach(obj => {
                    if (parties.filter(k => k.Miflaga == obj).length > 0) {
                        badMiflaga = obj;
                        willNotSit = true;
                    }
                })
                break;
            case "הרשימה המשותפת":
                ["הליכוד", "ימינה", "ישראל ביתנו", "תקווה חדשה", "הציונות הדתית"].forEach(obj => {
                    if (parties.filter(k => k.Miflaga == obj).length > 0) {
                        badMiflaga = obj;
                        willNotSit = true;
                    }
                })
                break;
            case "יש עתיד":
                ["הליכוד", "הציונות הדתית", "ש\"ס"].forEach(obj => {
                    if (parties.filter(k => k.Miflaga == obj).length > 0) {
                        badMiflaga = obj;
                        willNotSit = true;
                    }
                })
                break;
            case "ש\"ס":
                ["יש עתיד", "ישראל ביתנו"].forEach(obj => {
                    if (parties.filter(k => k.Miflaga == obj).length > 0) {
                        badMiflaga = obj;
                        willNotSit = true;
                    }
                })
                break;
            case "העבודה":
                ["הציונות הדתית", "הליכוד"].forEach(obj => {
                    if (parties.filter(k => k.Miflaga == obj).length > 0) {
                        badMiflaga = obj;
                        willNotSit = true;
                    }
                })
                break;
            case "הציונות הדתית":
                ["העבודה", "מרצ", "הרשימה המשותפת", "תקווה חדשה", "יש עתיד"].forEach(obj => {
                    if (parties.filter(k => k.Miflaga == obj).length > 0) {
                        badMiflaga = obj;
                        willNotSit = true;
                    }
                })
                break;
            case "מרצ":
                ["הציונות הדתית", "הליכוד"].forEach(obj => {
                    if (parties.filter(k => k.Miflaga == obj).length > 0) {
                        badMiflaga = obj;
                        willNotSit = true;
                    }
                })
                break;
            case "יהדות התורה":
                ["ישראל ביתנו"].forEach(obj => {
                    if (parties.filter(k => k.Miflaga == obj).length > 0) {
                        badMiflaga = obj;
                        willNotSit = true;
                    }
                })
                break;
        }
        // if (willNotSit) {
        //     delete items[item.index];
        //     delete itemsClicked[item.index];
        //     this.setState({
        //         itemsClicked,
        //         items
        //     })
        //     this.props.togglePopup(<PopupError
        //         togglePopup={this.props.togglePopup}
        //         partOne={item.name}
        //         partTwo={badMiflaga} />);
        //     return;
        // }
        this.props.setCounter(item);
    }
    setClick = index => {
        let { itemsClicked } = this.state;
        itemsClicked = {
            ...itemsClicked,
            [index]: {
                isClicked: itemsClicked[index] ? (itemsClicked[index].isClicked ? false : true) : true
            }
        }
        this.setState({
            itemsClicked: itemsClicked
        }, () => {
            this.setState({
                renderSlider: true
            });
        })
    }
    setOwlRef = ref => {
        this.setState({
            OwlRef: ref
        })
    }
    renderMiflagot = () => {
        return this.state.data.sort((a, b) => b.mandats - a.mandats).map((item, index) => <InnerItem key={index} index={index}
            checkCombinations={this.checkCombinations}
            setClick={this.setClick}
            setData={this.setData}
            sendScore={this.props.setCounter}
            isActive={this.state.itemsClicked[index] && this.state.itemsClicked[index].isClicked == true}
            {...item} />);

    }
    render() {
        return (
            <section className="section section-miflagot">
                <Loading showLoading={this.state.data.length == 0} />
                <div className="padding">
                    <div className="container">
                        {/* <div className="slider candidates">
                            {mobile() ? 
                            <Slider
                                renderSlider={this.state.renderSlider}
                                setOwlRef={this.setOwlRef}>
                                {this.renderMiflagot()}
                            </Slider> : ""}
                        </div> */}
                        <div className="miflagots">
                            <div className="mobile-scroll" style={mobile() ? {
                                width: `${(((170 / 640) * 100)) * this.state.data.length}vw`
                            } : {}}>
                                {this.renderMiflagot()}
                            </div>
                        </div>
                        {/* <div className="note">
                            * לפי מדגם רשת
                        </div> */}
                        <div className="note">
                        לפי תוצאות אמת חלקיות
                        </div>
                        {/* <div className="note">
                            מספרי המנדטים מתבססים על סקר "ידיעות אחרונות" שפורסם בתאריך {this.state.dateUpdated}
                        </div> */}
                    </div>
                </div>
            </section>
        )
    }
}


// WEBPACK FOOTER //
// ./src/Components/Miflagot/Miflagot.jsx